type QueryValue = string | (string | null)[] | null | undefined;

export function catalogPage(value: QueryValue): number {
  const page = Number(Array.isArray(value) ? value[0] : value);
  return Number.isSafeInteger(page) && page > 0 ? page : 1;
}

export function catalogCanonicalPath(path: string, page: QueryValue): string {
  const number = catalogPage(page);
  return number > 1 ? `${path}?page=${number}` : path;
}

export function catalogPaginationPages(current: number, last: number, pagerCount = 7): (number | string)[] {
  const pages = new Set([1, last]);
  const window = pagerCount - 2;
  const half = Math.floor(window / 2);
  const start = Math.max(2, Math.min(current - half, last - window));
  const end = Math.min(last - 1, Math.max(current + half, window + 1));
  for (let page = start; page <= end; page++) pages.add(page);

  const result: (number | string)[] = [];
  let previous = 0;
  for (const page of [...pages].sort((a, b) => a - b)) {
    if (page - previous > 1) result.push(`gap-${page}`);
    result.push(page);
    previous = page;
  }
  return result;
}
